import PropTypes from 'prop-types';
import React from 'react';
import T from 'components/T';
import { i18n } from '@international/mastodon-i18n';
import IconPanel from '../../../IconPanel';
import pendingIcon from '../../../../images/icons/Pending.svg';

const CONFIRMATION_KEY_MAP = {
  candidate_exception_resolved:
    'components.Report.ETA.confirmationCandidateResolved',
  past_eta: 'components.Report.ETA.confirmationDelayed',
  new_provider_eta: 'components.Report.ETA.confirmationDelayed',
  new_screening: 'components.Report.ETA.confirmationNewScreening',
};

const getConfirmationKey = (latestPredictionType, partialReportCompleted) => {
  let result = CONFIRMATION_KEY_MAP[latestPredictionType];

  if (!result) {
    result = partialReportCompleted
      ? 'components.Report.ETA.nonCriminalScreeningsCompletedConfirmation'
      : 'components.Report.ETA.confirmation';
  }

  return result;
};

const PendingNotice = ({
  applyMessaging,
  latestPredictionType,
  companyName,
  partialReportCompleted,
}) => {
  const confirmationKey = getConfirmationKey(
    latestPredictionType,
    partialReportCompleted,
  );

  return (
    <IconPanel
      translationKey={
        applyMessaging
          ? 'components.Report.applyPendingNotice'
          : 'components.Report.PendingNotice'
      }
      icon={
        <img
          src={pendingIcon}
          alt={i18n.getStr('components.Report.reportPending')}
        />
      }
      detailsCentered
    >
      <div className='text-center'>
        <T value={confirmationKey} companyName={companyName} />
      </div>
    </IconPanel>
  );
};

PendingNotice.propTypes = {
  applyMessaging: PropTypes.bool,
  companyName: PropTypes.string,
  latestPredictionType: PropTypes.string,
  partialReportCompleted: PropTypes.bool,
};

PendingNotice.defaultProps = {
  applyMessaging: false,
  companyName: '',
  latestPredictionType: null,
  partialReportCompleted: false,
};

export default i18n.renderTranslation()(PendingNotice);
